import wretch from 'wretch'
import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import { getCsrfToken } from '../../utils/csrf'

const loadState = () => {
  try {
    const authData = { csrf: getCsrfToken() }
    const profile = localStorage.getItem('profile')
    saveState({ authData })
    return {
      authData: authData, 
      profile: profile ? JSON.parse(profile) : null
    }
  } catch (err) {
    console.error('Erreur lors du chargement du state depuis localStorage:', err)
    return {
      authData: null,
      profile: null
    }
  }
}

// Fonction utilitaire pour sauvegarder les données dans le localStorage
export const saveState = (state) => {
  try {
    if(state.authData) localStorage.setItem('authData', JSON.stringify(state.authData))
    if(state.profile) localStorage.setItem('profile', JSON.stringify(state.profile))
  } catch (err) {
    console.error(err)
  }
}

const clearState = () => localStorage.clear()

export const fetchProfile = createAsyncThunk('auth/data', async (_, { dispatch, fulfillWithValue, rejectWithValue }) => {
  let profile = JSON.parse(localStorage.getItem('profile')) || null

  if (!profile) {
    try {
    // Appeler une API pour récupérer les données d'authentification et le profil
    await wretch()
      .get('/auth/session_info')
      .timeout( error => 
        console.error({text: error.text || "Le serveur ne répond pas. Veuillez vérifier votre connexion internet ou réessayer plus tard.", type: "error"})
      )
      .json( (response) => {
        if(response.authenticated) { profile = response.data }
      })
    
      dispatch(setProfile(profile))
      return fulfillWithValue()
    } catch(error) {
      console.error(error)
      return rejectWithValue()
    }
  } else {
    dispatch(setProfile(profile))
  }
})


const initialState = {
  ...loadState()
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action) => {
      state.authData = action.payload
      saveState(state)
    },
    setCsrfToken: (state, action) => {
      state.authData = { csrf: action.payload }
      saveState(state)
    },
    setProfile: (state, action) => {
      state.profile = action.payload
      saveState(state)
    },
    clearAuthData: (state) => {
      state.authData = null
      state.profile = null
      clearState()
    }
  }
})

export const { setAuthData, setCsrfToken, setProfile, clearAuthData } = authSlice.actions
export default authSlice.reducer

export const selectIfUserIsAdmin = createSelector(
  [state => state.auth.profile],
  (profile) => profile.admin === true
)